<template>
  <v-flex v-if="companyChart">
    <h4 class="text-27-security blue-security text-xs-center font-weight-bold">
      Relacionados
    </h4>
    <hr v-if="parents.father.length" />
    <br />
    <!-- Father -->
    <v-layout row wrap justify-center v-if="parents.father.length">
      <v-flex md2>
        <CardUserFather
          :user="parents.father[0]"
          :showUser="showUser"
          :scrollToTop="scrollToTop"
        />
      </v-flex>
    </v-layout>
    <!-- End Father -->
    <hr class="mt-4 mb-4" />
    <!-- User and siblings -->
    <v-layout class row wrap justify-center>
      <v-flex md2 mr-2 pt-2>
        <CardUserSibling
          :user="parents"
          :showUser="showUser"
          :scrollToTop="scrollToTop"
          :isCurrentUser="true"
        />
      </v-flex>
      <v-flex md2 mr-2 pt-2 v-for="sibling in parents.siblings" :key="sibling.id">
        <CardUserSibling 
          :user="sibling"
          :showUser="showUser"
          :scrollToTop="scrollToTop"
          :isCurrentUser="false"
        />
      </v-flex>
    </v-layout>
    <!-- End selected_user and siblings -->
    <hr v-if="parents.childrens.length" class="mt-4 mb-4" />
    <!-- Childrens -->
    <v-layout row wrap justify-center v-if="parents.childrens.length">
      <v-flex md2 mr-2 pt-2 v-for="children in parents.childrens" :key="children.id">
        <CardUserChildren
          :user="children"
          :showUser="showUser"
          :scrollToTop="scrollToTop"
        />
      </v-flex>
    </v-layout>
    <!-- Ends Childrens -->
  </v-flex>
</template>

<script>
import { mapActions, mapState } from "vuex";
import CardUserFather from '@/components/User/CardUserFather';
import CardUserSibling from '@/components/User/CardUserSibling';
import CardUserChildren from '@/components/User/CardUserChildren';

export default {
  components: {
    CardUserFather,
    CardUserSibling,
    CardUserChildren,
  },
  props: {
    parents: {
      type: Object,
      required: true,
    },
    companyChart: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapState("user", ["user", "current_user"])
  },
  methods: {
    ...mapActions("user", ["fetchUser"]),
    showUser(user) {
      this.fetchUser(user.id);
      if (user.id == this.current_user.id) {
        this.$router.push({ name: "profile" });
      } else {
        this.$router.push({ name: "user-show", params: { id: user.id } });
      }
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  },
}
</script>